import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const SanAntonio = () => {
  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Valves San Antonio | Industrial Equipment Buyers San Antonio Texas';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves San Antonio Texas - Professional valve buyers in San Antonio. We buy surplus valves, Fisher control valves, instrumentation from Valero, NuStar refineries. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers san antonio, texas industrial equipment, surplus valves san antonio, fisher control valves texas, refinery equipment buyers');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/san-antonio');
    }

    // Add geo and schema data
    const geoPosition = document.createElement('meta');
    geoPosition.setAttribute('name', 'geo.position');
    geoPosition.setAttribute('content', '29.4241;-98.4936');
    document.head.appendChild(geoPosition);

    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-TX');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'San Antonio, Texas');
    document.head.appendChild(geoPlacename);

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/san-antonio/#webpage",
          "url": "https://valvesalessupply.com/san-antonio",
          "name": "San Antonio Texas Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply",
          "description": "Professional valve buyers San Antonio Texas - We buy surplus valves, Fisher control valves, instrumentation from Valero, NuStar refineries. Same-day response 214-854-5638."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in San Antonio Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from San Antonio area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Valero San Antonio, NuStar Energy, and other South Texas facilities."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(geoPosition);
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const faqData = [
    {
      question: "What types of valves do you buy in San Antonio Texas?",
      answer: "We buy all types of industrial valves from San Antonio area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Valero San Antonio, NuStar Energy, and other South Texas facilities."
    },
    {
      question: "How quickly can you respond to San Antonio facilities?",
      answer: "We provide same-day response to all San Antonio and South Central Texas facilities. Our Texas team can typically be on-site within 2-4 hours for equipment assessments from our regional operations center."
    },
    {
      question: "Do you buy pipeline equipment from San Antonio area?",
      answer: "Yes! We purchase pipeline valves, terminal equipment, storage tank instrumentation, and distribution facility equipment from San Antonio area operations. We handle both refinery and midstream equipment purchases."
    },
    {
      question: "What documentation do you provide for Texas facilities?",
      answer: "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with Texas state and federal regulations."
    },
    {
      question: "Do you coordinate with planned maintenance schedules?",
      answer: "Absolutely! We work within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment. Our team understands South Texas refinery operational schedules."
    },
    {
      question: "How do you price equipment from San Antonio refineries?",
      answer: "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all San Antonio area facilities."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/cf3c6f4882208d64ca7df8ced188b951.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves San Antonio Texas</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers San Antonio</strong> South Central Texas - We purchase surplus valves, control valves, 
              instrumentation, and refinery equipment from Valero, NuStar Energy, and regional facilities. 
              Same-day response and competitive pricing for all South Texas operations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET SAN ANTONIO QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in San Antonio
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater San Antonio metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">North San Antonio</h3>
              <p className="text-gray-600">Stone Oak, Alamo Heights, Castle Hills areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">South San Antonio</h3>
              <p className="text-gray-600">Southside, Brooks City Base, Palo Alto areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibent text-gray-900 mb-3">West San Antonio</h3>
              <p className="text-gray-600">Westside, Medical Center, UTSA areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in San Antonio
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality industrial equipment from leading manufacturers throughout San Antonio, Texas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-red-50 to-orange-50 p-6 rounded-lg border border-red-100">
              <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Control Valves San Antonio</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves San Antonio, Masoneilan San Antonio, Q-Check San Antonio, Valtek San Antonio
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Fisher San Antonio</span>
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Masoneilan SA</span>
                <span className="px-2 py-1 bg-red-100 text-red-800 text-sm rounded">Q-Check SA</span>
              </div>
              <a href="/contact" className="text-red-600 hover:text-red-700 font-medium">Get SA Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation SA</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters San Antonio, Foxboro San Antonio, Fisher Instruments SA, Barton San Antonio
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Rosemount SA</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Foxboro SA</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Fisher SA</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get SA Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Water Systems SA</h3>
              <p className="text-gray-600 mb-4">
                Badger Water Meters San Antonio, Neptune San Antonio, Rockwell San Antonio, municipal equipment
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Badger SA</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Neptune SA</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Rockwell SA</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get SA Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators San Antonio</h3>
              <p className="text-gray-600 mb-4">
                Limitorque San Antonio, Bettis Actuators San Antonio, Fisher Actuators SA, Q-Check Actuators SA
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque SA</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis SA</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher SA</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get SA Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings San Antonio</h3>
              <p className="text-gray-600 mb-4">
                Swagelok San Antonio, Parker Fittings San Antonio, Anderson Greenwood SA, Hoke San Antonio
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Swagelok SA</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Parker SA</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Anderson SA</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get SA Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temperature San Antonio</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges San Antonio, All Temp Sensors SA, OCI San Antonio, McDaniel San Antonio
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA SA</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp SA</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI SA</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get SA Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in San Antonio?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus industrial equipment in San Antonio, Texas
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SAN ANTONIO VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to South Central Texas buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SanAntonio;
